// extracted by mini-css-extract-plugin
export default {"departments":"oF-z","departmentHeading":"pF-z","departmentSection":"qF-z","departmentName":"rF-z","departmentLink":"sF-z","expandIcon":"tF-z"};